import { useEffect, useState } from "react";

const TemplateOptions = {
  ApoluxDeDuiven: "apolux_de_duiven",
  ApoluxDeDuivenMobile: "apolux_de_duiven_mobile",
  Apodiscounter: "apodiscounter",
  ApodiscounterMobile: "apodiscounter_mobile",
  ApothekeAt: "apotheke_at",
  ApothekeAtMobile: "apotheke_at_mobile",
  VersandapoDe: "versandapo_de",
  VersandapoDeMobile: "versandapo_de_mobile",
  JuvalisDe: "juvalis_de",
  JuvalisDeMobile: "juvalis_de_mobile",
  DeutscheInternetApothekeDe: "deutsche_internet_apotheke_de",
  DeutscheInternetApothekeDeMobile: "deutsche_internet_apotheke_de_mobile",
  ApodiscounterPl: "apodiscounter_pl",
  ApodiscounterPlMobile: "apodiscounter_pl_mobile",
  ApothekeDe: "apotheke_de",
  ApothekeDeMobile: "apotheke_de_mobile",
} as const;

type Templates = (typeof TemplateOptions)[keyof typeof TemplateOptions];

const useTemplate = () => {
  const [template, setTemplate] = useState<Templates | null>(null);
  const [isApolux, setIsApolux] = useState(false);
  const [isApodiscounter, setIsApodiscounter] = useState(false);
  const [isVersandapo, setIsVersandapo] = useState(false);
  const [isApotheke, setIsApotheke] = useState(false);
  const [isJuvalis, setIsJuvalis] = useState(false);
  const [isDeutsche, setIsDeutsche] = useState(false);
  const [isApodiscounterPl, setIsApodiscounterPl] = useState(false);
  const [isApothekeDe, setIsApothekeDe] = useState(false);

  useEffect(() => {
    const storedTemplate = localStorage.getItem("template");
    if (storedTemplate) {
      const extractedTemplate = storedTemplate.split("/").filter(Boolean).pop() as Templates;
      if (extractedTemplate !== template) {
        setTemplate(extractedTemplate || null);

        switch (extractedTemplate) {
          case "apolux_de_duiven":
          case "apolux_de_duiven_mobile":
            setIsApolux(true);
            break;
          case "apodiscounter":
          case "apodiscounter_mobile":
            setIsApodiscounter(true);
            break;
          case "versandapo_de":
          case "versandapo_de_mobile":
            setIsVersandapo(true);
            break;
          case "apotheke_at":
          case "apotheke_at_mobile":
            setIsApotheke(true);
            break;
          case "juvalis_de":
          case "juvalis_de_mobile":
            setIsJuvalis(true);
            break;
          case "deutsche_internet_apotheke_de":
          case "deutsche_internet_apotheke_de_mobile":
            setIsDeutsche(true);
            break;
          case "apodiscounter_pl":
          case "apodiscounter_pl_mobile":
            setIsApodiscounterPl(true);
            break;
          case "apotheke_de":
          case "apotheke_de_mobile":
            setIsApothekeDe(true);
            break;
          default:
            setIsApolux(false);
            setIsApodiscounter(false);
            setIsVersandapo(false);
            setIsApotheke(false);
            setIsJuvalis(false);
            setIsDeutsche(false);
            setIsApothekeDe(false);
            setIsApodiscounterPl(false);
            break;
        }
      }
    }
  }, [template]);

  return { template, isApolux, isApodiscounter, isVersandapo, isApotheke, isJuvalis, isDeutsche, isApodiscounterPl, isApothekeDe };
};

export default useTemplate;
